export interface ThemedLogoSrcs {
    /** Logo variant for the light theme (dark ink). */
    light: string;
    /** Logo variant for the dark theme (white ink). */
    dark: string;
}

const IMAGE_EXTENSIONS = ['png', 'svg', 'jpg', 'jpeg', 'webp', 'gif'];

/**
 * Derive theme-specific logo paths from a client's base `logoUrl` by convention.
 *
 * `/niw-orbit.png` → `{ light: '/niw-orbit-light.png', dark: '/niw-orbit-dark.png' }`
 *
 * Only same-origin `public/` paths (starting with a single `/`) that end in a known image
 * extension are transformed — those are the only cases where matching `-light`/`-dark`
 * siblings are guaranteed to exist. Anything else (null, an absolute/protocol-relative/data
 * URL, or an unrecognised extension) returns `null` so callers fall back to the base image.
 */
export function getThemedLogoSrcs(logoUrl?: string | null): ThemedLogoSrcs | null {
    if (!logoUrl) return null;
    if (!logoUrl.startsWith('/') || logoUrl.startsWith('//')) return null;

    const dot = logoUrl.lastIndexOf('.');
    if (dot <= 0) return null;

    const ext = logoUrl.slice(dot + 1).toLowerCase();
    if (!IMAGE_EXTENSIONS.includes(ext)) return null;

    const base = logoUrl.slice(0, dot);
    return { light: `${base}-light.${ext}`, dark: `${base}-dark.${ext}` };
}
